import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - custom pages
const MasterAnggota = Loadable(lazy(() => import('pages/master/anggota')));
const MasterPembayaran = Loadable(lazy(() => import('pages/master/pembayaran')));
const MasterAkun = Loadable(lazy(() => import('pages/master/akun')));
const InputTransaksi = Loadable(lazy(() => import('pages/transaksi/input')));
const InputPengeluaran = Loadable(lazy(() => import('pages/transaksi/pengeluaran')));
const DaftarTransaksi = Loadable(lazy(() => import('pages/transaksi/daftar')));
const TarikPembayaran = Loadable(lazy(() => import('pages/laporan/tarik-pembayaran')));
const QrcodeLaporan = Loadable(lazy(() => import('pages/laporan/qrcode')));

// render - absensi
const AbsensiSiswa = Loadable(lazy(() => import('pages/absensi/siswa')));
const AbsensiRiwayat = Loadable(lazy(() => import('pages/absensi/riwayat')));
const AbsensiForm = Loadable(lazy(() => import('pages/absensi/form')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'master',
      children: [
        {
          path: 'anggota',
          element: <MasterAnggota />
        },
        {
          path: 'pembayaran',
          element: <MasterPembayaran />
        },
        {
          path: 'akun',
          element: <MasterAkun />
        }
      ]
    },
    {
      path: 'transaksi',
      children: [
        {
          path: 'input',
          element: <InputTransaksi />
        },
        {
          path: 'pengeluaran',
          element: <InputPengeluaran />
        },
        {
          path: 'daftar',
          element: <DaftarTransaksi />
        }
      ]
    },
    {
      path: 'laporan',
      children: [
        {
          path: 'tarik-pembayaran',
          element: <TarikPembayaran />
        },
        {
          path: 'qrcode',
          element: <QrcodeLaporan />
        }
      ]
    },
    {
      path: 'absensi',
      children: [
        {
          path: 'siswa',
          element: <AbsensiSiswa />
        },
        {
          path: 'riwayat',
          element: <AbsensiRiwayat />
        },
        {
          path: 'form',
          element: <AbsensiForm />
        }
      ]
    }
  ]
};

export default MainRoutes;
